<script>
import { ref } from 'vue';
import { useAI } from 'dashboard/composables/useAI';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import AITranslateModal from './AITranslateModal.vue';
import { emitter } from 'shared/helpers/mitt';
import { CMD_AI_TRANSLATE } from 'dashboard/helper/commandbar/events';

export default {
  components: {
    NextButton,
    AITranslateModal,
  },
  emits: ['replaceText'],
  setup() {
    const { isAIIntegrationEnabled, draftMessage } = useAI();
    const isModalVisible = ref(false);
    const selectedLanguage = ref({ code: '', label: '' });

    return {
      isAIIntegrationEnabled,
      draftMessage,
      isModalVisible,
      selectedLanguage,
    };
  },
  computed: {
    translateTooltip() {
      return this.$t('INTEGRATION_SETTINGS.OPEN_AI.TRANSLATE.BUTTON_TOOLTIP');
    },
    hasDraftMessage() {
      return !!this.draftMessage?.trim();
    },
  },
  mounted() {
    emitter.on(CMD_AI_TRANSLATE, this.onTranslateCommand);
  },
  beforeUnmount() {
    emitter.off(CMD_AI_TRANSLATE, this.onTranslateCommand);
  },
  methods: {
    openTranslateMenu() {
      if (!this.isAIIntegrationEnabled) {
        return;
      }

      if (!this.hasDraftMessage) {
        useAlert(
          this.$t('INTEGRATION_SETTINGS.OPEN_AI.TRANSLATE.NO_DRAFT_WARNING')
        );
        return;
      }

      const ninja = document.querySelector('ninja-keys');
      if (ninja) {
        ninja.open({ parent: 'ai_translate' });
      }
    },
    onTranslateCommand(payload = {}) {
      const { targetLanguage, targetLanguageLabel } = payload;
      if (!targetLanguage) {
        return;
      }

      this.selectedLanguage = {
        code: targetLanguage,
        label: targetLanguageLabel || targetLanguage.toUpperCase(),
      };
      this.isModalVisible = true;
    },
    hideModal() {
      this.isModalVisible = false;
    },
    onApplyText(message) {
      this.$emit('replaceText', message);
      this.hideModal();
    },
  },
};
</script>

<template>
  <div v-if="isAIIntegrationEnabled" class="relative">
    <NextButton
      v-tooltip.top-end="translateTooltip"
      icon="i-ph-translate"
      slate
      faded
      sm
      :disabled="!hasDraftMessage"
      @click="openTranslateMenu"
    />
    <woot-modal v-model:show="isModalVisible" :on-close="hideModal">
      <AITranslateModal
        :target-language="selectedLanguage.code"
        :language-label="selectedLanguage.label"
        @apply-text="onApplyText"
        @close="hideModal"
      />
    </woot-modal>
  </div>
</template>
